import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { OverlayLoaderTID } from '../../../providers/OverlayContextProvider';
import { getTestIds } from '../../../utils/TestIds';
import { Loader } from '../../Loader';
import styles from './GlobalLoader.module.scss';
export const GetGlobalLoaderTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            GlobalLoaderTID: {
                Root: 'global-loader'
            }
        }
    });
export function GlobalLoader(param) {
    let { scoped } = param;
    const { GlobalLoaderTID } = useMemo(()=>GetGlobalLoaderTID(), []);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.globalLoader, {
            [styles.scoped]: scoped
        }),
        "data-testid": GlobalLoaderTID.Root(),
        children: [
            /*#__PURE__*/ _jsx("div", {
                "data-testid": OverlayLoaderTID,
                className: styles.overlay
            }),
            /*#__PURE__*/ _jsx(Loader, {})
        ]
    });
}
